function isElementInViewport (el) {
  var rect = el.getBoundingClientRect();

  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}
const atcObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {      
      if(entry.isIntersecting){
        entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.remove('active');
      } else {
        entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.add('active');
      }
    });
  },
  {
    threshold: 0.25
  }
);

const atcObserver2 = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {      
      if(entry.isIntersecting){
        if (isElementInViewport(document.querySelector('.product__info-select-size-trigger'))) {
          entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.remove('active');
        } else {
          entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.add('active');
        }
      } else {
        entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.remove('active');
      }
    });
  },
  {
    threshold: .025
  }
);    

if(document.querySelector('.sticky-atc')){
    atcObserver.observe(document.querySelector('.product__info-select-size-trigger'));

    if (window.innerWidth > 768) {
      setTimeout(() => {
        atcObserver2.observe(document.querySelector('#main-carousel'));  
      }, 50);
    }

    document.querySelector('.sticky-atc').addEventListener('click', () => {
      document.querySelector('.product__info-select-size-trigger').click()
    })  
}  
